import { z } from 'zod';
import { DEFINITION_SOURCES } from '@internal/backstage-plugin-pulse-common';

export { trackImportDefinitionSchema } from '@internal/backstage-plugin-pulse-common';

export const trackLevelSchema = z.object({
  ordinal: z.number().int().min(1),
  description: z.string().optional(),
  importance: z.enum(['mandatory', 'recommended']),
  checkIds: z.array(z.string().min(1)),
});

export const trackDefinitionSchema = z.object({
  id: z.string().min(1),
  ownerEntityRef: z.string().min(1),
  name: z.string().min(1),
  createdAt: z.iso.datetime({ offset: true }).optional(),
  updatedAt: z.iso.datetime({ offset: true }).optional(),
  source: z.enum(DEFINITION_SOURCES).optional(),
  description: z.string().optional(),
  documentationUrl: z.string().optional(),
  filter: z.array(z.record(z.string(), z.unknown())).optional(),
  exclude: z.array(z.record(z.string(), z.unknown())).optional(),
  inactive: z.boolean().optional(),
  levels: z.array(trackLevelSchema),
});

export const tracksResponseSchema = z.object({
  tracks: z.array(trackDefinitionSchema).default([]),
});

export const trackImportResultSchema = z.object({
  total: z.number().int().nonnegative(),
  imported: z.array(z.string()),
  skipped: z.array(z.string()),
  failed: z.array(
    z.object({
      id: z.string().optional(),
      reason: z.string(),
    }),
  ),
});

export const trackLevelResultSchema = z.object({
  ordinal: z.number(),
  passedChecks: z.number(),
  totalChecks: z.number(),
  percentage: z.number(),
  passed: z.boolean(),
});

export const trackResultSchema = z.object({
  trackId: z.string(),
  entityRef: z.string(),
  trackPassed: z.boolean().optional(),
  achievedLevel: z.number(),
  overallPassedChecks: z.number(),
  overallTotalChecks: z.number(),
  overallPercentage: z.number(),
  levels: z.array(trackLevelResultSchema),
});

export const trackResultsResponseSchema = z.object({
  track: trackDefinitionSchema,
  results: z.array(trackResultSchema),
});

export const entityTrackResultsResponseSchema = z.object({
  results: z.array(trackResultSchema),
});

export const trackHistoryPointSchema = z.object({
  date: z.string(),
  levels: z.array(
    z.object({
      ordinal: z.number(),
      entityCount: z.number(),
    }),
  ),
});

export const trackHistoryResponseSchema = z.object({
  trackId: z.string(),
  history: z.array(trackHistoryPointSchema),
});
